/*
  This is the main entrypoint for the app.

  Add app-wide javascript to 'app/assets/javascripts/shared'
  Add page-specific javascript to 'app/assets/javascripts/pages'
  Javascript from partials can be added to 'app/assets/javscripts/partials'

  For the moment, we load all javascript in this file so files need to be
  explicitly imported below.
*/

// Polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// Import libraries
import Rails from '@rails/ujs';

// Manually import js files for now
import 'pages/checkout';
import 'pages/static_tracking';
import 'pages/devise/registrations';
import 'pages/devise/sessions';
import 'pages/devise/passwords';
import 'partials/blueprints/focus';
import 'partials/blueprints/sections/footer';
import 'partials/blueprints/sections/image_hero';
import 'partials/blueprints/sections/marketing_header';
import 'partials/blueprints/sections/header/browse_dropdown';
import 'partials/blueprints/sections/header/header';
import 'partials/blueprints/sections/header/account_dropdown';
import 'partials/blueprints/sections/header/account_overlay';
import 'partials/blueprints/sections/header/burger_menu_overlay';
import 'partials/blueprints/sections/header/shopping_cart';
import 'partials/landers/unbeatable_deals_page_body';
import 'partials/modals/heard_about_modal';
import 'partials/modals/no_longer_interested_modal';

import visibleIcon from 'images/visible';
import invisibleIcon from 'images/invisible';

// ES6 imports
import _ from 'lodash';
import Cookies from 'js-cookie';
import { bubEvents } from 'shared/events/bub_events';
import { attributionHelper } from 'shared/attribution_helper'; // Used by OptinMonster popups
import { SiteConversionTrackingHelper, SiteImpressions } from 'shared/events/site_conversion_tracking_helper';
import {
  mountDataPrivacyLanguage,
  mountEmailSuggestor,
  mountEmailErrorDisplayer,
  preventDoubleSignupSubmit,
} from 'partials/forms/sign_up_form';
import { BrowserAbilities } from 'shared/utils/browser_abilities';
import { BrowserSupported } from 'shared/utils/browser_supported';
import { DomainChecker } from 'shared/utils/domain_checker';

// Add global libraries to the window
window._ = _;
window.$ = $;
window.Cookies = Cookies;
window.BrowserAbilities = BrowserAbilities;
window.BrowserSupported = BrowserSupported;
window.bubEvents = bubEvents;
window.attributionHelper = attributionHelper;
window.SiteConversionTrackingHelper = SiteConversionTrackingHelper;

// Start UJS
Rails.start();

$(() => {
  bubEvents.trackPageVisit();
  bubEvents.trackMycroftTests();
  BrowserAbilities.init();

  const $bookUnavailableFlash = $('.flash.info-container .message-text');

  if (
    $bookUnavailableFlash.length &&
    $bookUnavailableFlash[0].innerText === 'Sorry, that title is not currently available on Chirp.'
  ) {
    SiteImpressions.trackImmediately({
      category: 'Flash message',
      action: 'Viewed flash message',
      eventLabel: 'title unavailable',
    });
  }

  const $signUpForm = $('.sign-up-form');
  if ($signUpForm.length) {
    mountDataPrivacyLanguage({
      $signUpForm,
    });
    mountEmailSuggestor({
      $signUpForm,
    });
    mountEmailErrorDisplayer({
      $signUpForm,
    });
    preventDoubleSignupSubmit({
      $signUpForm,
    });
  }

  const $emailSignUpForm = $('.email-sign-up-form');
  if ($emailSignUpForm.length) {
    mountEmailSuggestor({
      $signUpForm: $emailSignUpForm,
    });
    mountEmailErrorDisplayer({
      $signUpForm: $emailSignUpForm,
    });
  }

  const $passwordField = $('.user-password-field');
  if ($passwordField.length) {
    const toggle = $('.password-toggle');
    toggle.on('click', () => {
      const currentlyPassword = $passwordField.attr('type') === 'password';
      const newType = currentlyPassword ? 'text' : 'password';
      $passwordField.attr('type', newType);

      const img = $('.toggle-image');
      img.attr('alt', `${currentlyPassword ? 'Hide' : 'Show'} password`);
      img.attr('src', currentlyPassword ? visibleIcon : invisibleIcon);
    });
  }
});

$(document).ready(() => {
  $('.google-play-link').on('click touch', () => {
    if (window.gtag !== undefined) {
      gtag('event', 'click', {
        event_category: 'play_store',
        event_label: document.title,
      });
    }
  });

  $('.ios-app-store-link').on('click touch', () => {
    if (window.gtag !== undefined) {
      gtag('event', 'click', {
        event_category: 'ios_app_store',
        event_label: document.title,
      });
    }
  });

  DomainChecker.reportUnsupportedDomain();
});
